import { Icon } from "@/components/Icon";
import { amountFormat } from "@/utils/tool";
import { Button, Grid, Space, SpinLoading } from "antd-mobile";
import styles from "./BalanceInfo.module.scss";
import { CopyIconWithText } from "@/components/CopyIconWithText";
import { UserInfo } from "@/types/Api/User/User/MyAccount/login";
import { RedoOutlined } from '@ant-design/icons';
type Props = {
  userInfo: UserInfo;
  loading: boolean;
  onRefresh: () => void;
};
export default function BalanceInfo({
  userInfo,
  loading,
  onRefresh
}: Props) {
  return <Grid columns={1} className={styles.balance_info} data-sentry-element="Grid" data-sentry-component="BalanceInfo" data-sentry-source-file="BalanceInfo.tsx">
      <Grid.Item className={styles.balance_info_vol} data-sentry-element="unknown" data-sentry-source-file="BalanceInfo.tsx">
        <Space data-sentry-element="Space" data-sentry-source-file="BalanceInfo.tsx">
          {amountFormat(userInfo.balance, {
          places: 2
        })}
          <div>
          <Icon name={"Vbi"} size={"24px"} className={styles.balance_info_icon} data-sentry-element="Icon" data-sentry-source-file="BalanceInfo.tsx" />
          <Button className={styles.loading} fill="none" onClick={() => onRefresh()} data-sentry-element="Button" data-sentry-source-file="BalanceInfo.tsx">
          {loading ? <SpinLoading style={{
              '--size': '12px'
            }} className={styles.loading_icon} /> : <RedoOutlined />}
          </Button>
          </div>
          
        </Space>
      </Grid.Item>
      <Grid.Item className={styles.balance_info_code} data-sentry-element="unknown" data-sentry-source-file="BalanceInfo.tsx">
        <Space data-sentry-element="Space" data-sentry-source-file="BalanceInfo.tsx">
          <CopyIconWithText text={userInfo.walletAddress} className={styles.balance_info_icon} encryption={true} isWalletAddress={true} data-sentry-element="CopyIconWithText" data-sentry-source-file="BalanceInfo.tsx" />
        </Space>
      </Grid.Item>
    </Grid>;
}